import cn from 'classnames'

import { getFormattedFinance } from '../../../../../../../../helpers/getFormattedFinance'
import { getQBRFormattedPt } from '../../../../../../helpers/getQBRFormattedPt'
import styles from '../SobAchievement.module.scss'

interface IGetSobAchievementCellParameters {
  actuals: number
  plans: number
  yoyActuals: number
  isTotal?: boolean
  isAlternativeTotal?: boolean
}

export const getSobAchievementCell = ({
  actuals,
  plans,
  yoyActuals,
  isTotal,
  isAlternativeTotal,
}: IGetSobAchievementCellParameters) => {
  return (
    <div
      className={cn(styles.financialValue, styles.fullView, {
        [styles.total]: isTotal,
        [styles.alternativeTotal]: isAlternativeTotal,
      })}
    >
      <p className={cn(styles.paragraph, styles.actuals)}>
        {getFormattedFinance(actuals, {
          maximumFractionDigits: 1,
          minimumFractionDigits: 1,
        })}
      </p>
      <p className={cn(styles.paragraph, styles.plans)}>
        {getFormattedFinance(plans, {
          maximumFractionDigits: 1,
          minimumFractionDigits: 1,
        })}
      </p>
      <p
        className={cn(styles.subParagraph, {
          [styles.positive]: yoyActuals > 0,
          [styles.negative]: yoyActuals < 0,
        })}
      >
        {getQBRFormattedPt(yoyActuals)}
      </p>
    </div>
  )
}
